export default __webpack_public_path__ + "static/media/flag-sint-eustatius.48c13fa5.svg";